import { NiceNavigationItem } from "@recursyve/nice-ui-kit.v2";
import { FlagsmithFeatureFlagNavigationResolver } from "../flagsmith/providers/flagsmith-feature-flag-navigation.resolver";

export const ownerNavigation: NiceNavigationItem[] = [
    {
        id: "home",
        type: "group",
        children: [
            {
                id: "dashboard",
                title: "navigation.dashboard",
                type: "basic",
                iconType: "svg",
                icon: "streamline-regular:layout-dashboard",
                link: "/dashboard/home"
            }
        ]
    },
    {
        type: "divider"
    },
    {
        id: "properties",
        type: "collapsable",
        title: "navigation.my_properties",
        iconType: "svg",
        icon: "streamline-regular:maps-pin-1",
        children: [],
        hidden: FlagsmithFeatureFlagNavigationResolver,
        meta: {
            featureKey: "owner_properties_access"
        }
    }
];
